import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './styleMenu.css';


const CustomMenuMouse = ({ menuPosition, handleClose, handleStopDrawing,isLineDrawing, removeLastPoint}) => {

  if(isLineDrawing && menuPosition != null){
      return (
        <Menu
          id="simple-menu"
          keepMounted
          open={Boolean(menuPosition)}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={menuPosition}
          className='menuStyle'
        >
          <label style={{color:'#eeeeee'}}>Действие</label>
          <hr className='horizontalLineMenu'/>
          <MenuItem className='menuItem' style={{marginBottom: "10px"}} onClick={() => { handleStopDrawing(); handleClose(); }}>Завершить</MenuItem>
          <MenuItem className='menuItem' onClick={() => { removeLastPoint(); handleClose(); }}>Удалить отрезок</MenuItem>
        </Menu>
      );
    }
}

export default CustomMenuMouse;